import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { v4 as uuidv4 } from 'uuid';

import { DEFAULT_ICON } from './EditAccordionBlock.constants';
import { TEXT_BLOCK_COMPONENT_NAME, TEXT_BLOCK_ELEMENT_TYPE } from '../../../../constants/types';

export function getPanelById(searchPanels, id) {
  return searchPanels.find((panel) => panel.id === id) || {};
}

export function updatePanelContentNames(panelNum) {
  return {
    titleContentName: `Accordion Panel ${panelNum} - Title`,
    contentContentName: `Accordion Panel ${panelNum} - Content`,
  };
}

export function getPanelWithUpdatedContentNames(panel, index) {
  const { titleContentName, contentContentName } = updatePanelContentNames(index + 1);
  const { title, content } = panel;
  return {
    ...panel,
    title: {
      ...title,
      contentName: titleContentName,
    },
    content: {
      ...content,
      contentName: contentContentName,
    },
  };
}

export function createDefaultPanel({ icon = DEFAULT_ICON } = {}) {
  return {
    id: uuidv4(),
    title: {
      className: '',
      style: {},
      componentConfigurationId: null,
      componentIdentifier: null,
      componentName: TEXT_BLOCK_COMPONENT_NAME,
      content: '',
      contentName: '',
      contentNodeConfigurationId: null,
      type: TEXT_BLOCK_ELEMENT_TYPE,
    },
    content: {
      className: '',
      style: {},
      componentConfigurationId: null,
      componentIdentifier: null,
      componentName: TEXT_BLOCK_COMPONENT_NAME,
      content: '',
      contentName: '',
      contentNodeConfigurationId: null,
      type: TEXT_BLOCK_ELEMENT_TYPE,
    },
    icon,
    exclusive: false,
    styled: false,
    isActive: false,
  };
}

export function getDefaultPanels() {
  return [createDefaultPanel()];
}

export function isValidPanels(panels) {
  const hasEmptyContent = panels.some((panel) => _isEmpty(_get(panel, 'content.content', '')));
  const hasEmptyTitle = panels.some((panel) => _isEmpty(_get(panel, 'title.content', '')));

  return !hasEmptyContent && !hasEmptyTitle;
}
